import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const userDefinition: ResourceDefinition = {
  title: 'Users',
  nameSingular: 'user',
  namePlural: 'users',
  className: 'User',
  icon: 'icon-user',
  mainIdentifier: 'name',
  slug: 'users',
  path: 'users',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.DETAIL],
  defaultLink: LinkType.DETAIL,
  childrenThatPreventDelete: [],
}
